/**
 * @file drivers.api.js
 * @module DriversAPI
 * @description HTTP API wrapper for driver related endpoints. Methods return Axios promises.
 * Usage example:
 * DriversAPI.getDriverById(id).then(response => ...)
 */

import { axiosInstance } from "./axios"

export const DriversAPI = {
    /**
     * Get drivers assigned to specific branches.
     * @param {string} _id - Branch identifier.
     * @param {string} token - Optional auth token.
     * @returns {Promise} Axios promise resolving to drivers list.
     */
    getDriversByBranches: async (_id, token = "") => {
        return await axiosInstance(token).get(`/drivers/branches/${_id}`);
    },

    /**
     * Update arbitrary attributes of a driver using PATCH.
     * @param {string} _id - Driver identifier.
     * @param {Object} body - Partial attributes to update.
     * @param {string} token - Optional auth token.
     * @returns {Promise} Axios promise resolving to updated driver.
     */
    updateAnyAttribute: async (_id, body, token = "") => {
        return await axiosInstance(token).patch(`/drivers/${_id}`, body);
    }
}